<template>
  <div>
    <Bar chart-id="1" :chart-data="chartData" :chart-options="chartOptions" />
  </div>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import { mapGetters } from "vuex";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "PaymentsFromGroup",
  components: {
    Bar,
  },
  mounted() {
    this.getPaymentsFromGroup();
  },
  data() {
    return {
      // Флаг для переключения между моками и API
      useMockData: false,
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Coins',
            data: [],
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1
          }
        ]
      }
    } 
  },
  computed: {
    ...mapGetters(["IS_WHITE_THEME"]),
    chartOptions() {
      // Подбираем цвета под текущую тему
      const textColor = this.IS_WHITE_THEME ? '#0e0e3d' : '#ddddde'; // $dark (#0e0e3d) или $gray-100 (#ddddde)
      const gridColor = this.IS_WHITE_THEME ? 'rgba(14, 14, 61, 0.1)' : 'rgba(255, 255, 255, 0.1)';

      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              color: textColor
            }
          }
        },
        scales: {
          y: {
            ticks: {
              color: textColor
            },
            grid: {
              color: gridColor
            }
          },
          x: {
            ticks: {
              color: textColor
            },
            grid: {
              color: gridColor
            }
          }
        }
      };
    }
  },
  methods: {
    getPaymentsFromGroup() {
      if (this.useMockData) {
        // Моковые данные
        const mockResponse = {
          data: [
            { coins: 150 },
            { coins: 320 },
            { coins: 210 },
            { coins: 450 },
            { coins: 180 },
            { coins: 600 }
          ]
        };
        this.setChartData(mockResponse.data);
      } else {
        // Оригинальная логика
        this.$store.dispatch('GET_GROUP_MONEY').then((response) => {
          this.setChartData(response.data);
        });
      }
    },
    // Вынес заполнение данных в отдельный метод для чистоты
    setChartData(data) {
      this.chartData.labels = data.map((item) => item.coins);
      this.chartData.datasets[0].data = data.map((item) => item.coins);
    }
  },
};
</script>